import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Input from '@mui/material/Input';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import BackHeader from '../components/BackHeader';
import BottomNav from '../components/BottomNav';
import Alert from '@mui/material/Alert';
import axios from 'axios';


export default function GenerateResult() {
  return (
    <div className="w-full h-screen bg-background bg-cover">

      <div className="flex flex-col h-full" style={{ borderBottomLeftRadius: 10, borderBottomRightRadius: 10 }}>
        <img src="/assets/imgs/example.png" style={{ aspectRatio: 1 / 1, marginBottom: 30, borderBottomLeftRadius: 10, borderBottomRightRadius: 10 }} />

        <div className="mt-5" />

        <Button variant="contained" color="primary" className="w-full">
          <Typography variant="h6" color="white">
            다시 생성하기
          </Typography>
        </Button>
      </div>
    </div>
  );
}